module.exports = __webpack_public_path__ + "static/media/Delete.23eac26f.svg";